import React, { ReactNode } from 'react';
import { I18n } from 'react-redux-i18n';
import { InvitationDTO, InvitationPopinEnum } from '../../../../network/api/types/InvitationDTO';
import { getHourBetweenDates } from '../../../../services/dateService';
import Button from '../../../common/Button';
import H4Title from '../../../common/H4Title';
import Modal from '../../../common/modals/Modal';

type Props = {
  show: boolean;
  close: () => void;
  entityName?: string;
  currentInvitation?: InvitationDTO;
  popinType: InvitationPopinEnum;
  handleClick?: () => void,
};

class ConfirmationModal extends React.Component<Props> {
  getEntityName = (): string => (this.props.entityName ? this.props.entityName : '');

  actionPopin = (): boolean => (this.props.popinType !== InvitationPopinEnum.CONFIRMATION);

  isInvitationExpired = (): boolean => {
    if (!this.actionPopin()) {
      return false;
    }
    if (!this.props.currentInvitation?.expiryDate) {
      return true;
    }
    const expiration = new Date(this.props.currentInvitation.expiryDate);
    return Date.now() > expiration.getTime();
  };

  getInfoMessage = (): string => {
    if (this.props.popinType === InvitationPopinEnum.CONFIRMATION) {
      return I18n.t('collaborators.invitation.popin.info');
    }
    if (this.isInvitationExpired()) {
      return I18n.t('collaborators.invitation.popin.expired');
    }
    let hoursRemaining = 0;
    if (this.props.currentInvitation?.expiryDate) {
      hoursRemaining = getHourBetweenDates(new Date(this.props.currentInvitation.expiryDate)
        .getTime());
    }
    return I18n.t('collaborators.invitation.popin.timeRemaining', { heures: hoursRemaining });
  };

  render(): ReactNode {
    return (
      <>
        <Modal
          isOpen={this.props.show}
          className="invitation-modal"
        >
          <div className="invitation-modal-container confirmation">
            <H4Title>
              {I18n.t(`collaborators.invitation.${this.props.popinType}.title`)}
            </H4Title>
            <div className="text">
              {I18n.t(`collaborators.invitation.${this.props.popinType}.desc`, { entity: this.getEntityName() })}
            </div>
            <div className="information-container">
              <div className="info-item">
                <div className="label">{I18n.t('collaborators.invitation.form.gender')}</div>
                <div>{this.props.currentInvitation?.gender}</div>
              </div>
              <div className="info-item">
                <div className="label">{I18n.t('collaborators.invitation.form.lastname')}</div>
                <div>{this.props.currentInvitation?.lastName}</div>
              </div>
              <div className="info-item">
                <div className="label">{I18n.t('collaborators.invitation.form.firstname')}</div>
                <div>{this.props.currentInvitation?.firstName}</div>
              </div>
              <div className="info-item">
                <div className="label">{I18n.t('collaborators.invitation.form.email')}</div>
                <div>{this.props.currentInvitation?.email}</div>
              </div>
              <div className={`time-remaining ${this.isInvitationExpired() ? 'expired' : ''}`}>
                {this.getInfoMessage()}
              </div>
            </div>
            {
              this.actionPopin()
              && (
                <div className="confirmation">
                  {I18n.t('collaborators.invitation.popin.confirmation')}
                </div>
              )
            }
            <div className="invitation-footer">
              <Button
                type="third"
                i18nKey={`actions.${this.actionPopin() ? 'CANCEL' : 'CLOSE'}`}
                onClick={this.props.close}
              />
              {
                this.actionPopin()
                && (
                  <Button
                    type="primary"
                    i18nKey={`collaborators.invitation.${this.props.popinType}.button`}
                    onClick={() => (
                      !!this.props.handleClick && this.props.handleClick()
                    )}
                  />
                )
              }
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default ConfirmationModal;
